import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer"
import { Machine } from "../../../utils/models/Machine"
import CompanyLogo from './../../../utils/resources/awayter_connect_light_cropped.png'
import { MachineTypes } from "../../../utils/const";

const styles = StyleSheet.create({
    page: {
        fontSize: 10,
    },
    generalSection: {
        border: '1 solid black',
        backgroundColor: '#fff',
        width: '300px'
    },
    section: {
        paddingHorizontal: 2,
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center'
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#25384A',
        color: '#fff',
        alignItems: 'center',
        justifyContent: 'center'
    },
    label: {
        fontWeight: 'bold',
        alignSelf: 'flex-end'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 3,
        marginRight: 3,
        justifyContent: "flex-start"
    },
    qrCodeContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    qrCode: {
        width: 100,
        height: 100,

    },
    logo: {
        width: 150
    },
    textContainer: {
        flexGrow: 1,  // Ocupa el resto del espacio disponible
        justifyContent: 'center',  // Centra los textos verticalmente
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 10
    },
    dataColumn: {
        display: 'flex',
        flexDirection: 'column'
    },
    dataColumnQr: {
        display: 'flex',
        flexDirection: 'column',
        margin: 10
    }
});

const QRFile = (props: { machine: Machine, qrCode: string, machineCode: string }) => {

    const machineTypes = MachineTypes()

    return (
        <Document>
            <Page style={styles.page} size={{ width: 300 }}>
                <View style={styles.generalSection}>
                    <View style={styles.header}>
                        <View style={styles.dataColumn}>
                            <View style={styles.qrCodeContainer}>
                                <Image src={CompanyLogo} style={styles.logo} />
                            </View>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.textContainer}>
                            <View style={styles.row}>
                                <Text style={styles.label}>MODEL</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>SERIAL N.</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>YEAR</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>ID</Text>
                            </View>
                        </View>
                        <View style={styles.textContainer}>
                            <View style={styles.row}>
                                <Text>{'AW_8842'}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text>{'000154826'}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text>{new Date().getFullYear()}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text>{'0.a3a5c314cce04d0'}</Text>
                            </View>
                        </View>
                        <View style={styles.dataColumnQr}>
                            <View style={styles.qrCodeContainer}>
                                <Image src={props.qrCode} style={styles.qrCode} />
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )

}

export default QRFile